import React, { useEffect, useState } from 'react';
import styles from '../styles.module.css';
import MainIcons from '@/icons/main';
import { useTranslations } from 'next-intl';
import FilterBlock from './FilterBlock';
import CategoryFilters from './CategoryFilters';
import AppLink from '@/components/common/AppLink';
import RatingFilters from './RatingFilters';
import Toggle from '@/components/common/Toggle';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import AttributeFilter from './AttributeFilter';
import Api from '@/api';
import { categoryType } from '@/commonTypes';
import { useLayoutContext } from '@/context/LayoutContext';
import PriceRange from './PriceRange';

export default function AttributeSection({
  categoryList,
  page = '/products',
  queryKey,
  info,
}: {
  categoryList?: categoryType[];
  page?: string;
  queryKey: string;
  info?: any;
}) {
  const tCommon = useTranslations('common');
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const { priceInfo, priceSymbol } = useLayoutContext();
  let mn = priceInfo?.min ? priceInfo?.min : 0;
  const [mx, setMx] = useState<number>(priceInfo?.max);

  const [minPrice, setMinPrice] = useState<number>(mn);
  const [maxPrice, setMaxPrice] = useState<number>(mx);
  useEffect(() => {
    if (priceInfo?.min && priceInfo?.max) {
      mn = priceInfo?.min;
      setMinPrice(priceInfo?.min);
      setMx(priceInfo?.max);
      setMaxPrice(priceInfo?.max);
    }
  }, [priceInfo]);

  const stockFunction = (key) => {
    const params = new URLSearchParams(searchParams.toString());
    if (params.get(key)) {
      params.delete(key);
    } else {
      params.set(key, '1');
    }
    params.set('page', '1');
    router.push(`${pathname}${params.toString() ? `?${params.toString()}` : ''}`);
  };

  // const [list, setList] = useState<categoryType[]>([]);

  // useEffect(() => {
  //   Api.categoryList({ start: 0, limit: 1000 })
  //     .then((res) => {
  //       setList(res?.data?.response);
  //     })
  //     .catch((err) => {});
  // }, []);
  return (
    <aside className={`${styles.filters} panel`}>
      <div className={`${styles.filters_head}`}>
        <h3>
          <MainIcons.filterIcon />
          {tCommon('filters')}
        </h3>
        <AppLink href={page} className={`${styles.clearAll}`}>
          {tCommon('clearAll')}
        </AppLink>
      </div>
      <FilterBlock title={info?.category?.title}>
        <CategoryFilters list={categoryList} queryKey={queryKey} />
      </FilterBlock>
      <FilterBlock title={tCommon('price')}>
        <PriceRange
          // data={data}
          minPrice={minPrice}
          setMinPrice={setMinPrice}
          maxPrice={maxPrice}
          setMaxPrice={setMaxPrice}
          mn={mn}
          mx={mx}
          setMx={setMx}
        />
      </FilterBlock>
      <AttributeFilter page={page} />
      <FilterBlock title={tCommon('ratingandup')}>
        <RatingFilters />
      </FilterBlock>

      {page == '/products' ? (
        <div className={`${styles.switchRow}`}>
          <span className={`${styles.title}`}>{tCommon('inStockOnly')}</span>
          <Toggle
            state={searchParams?.get('instock') ? true : false}
            onClick={() => stockFunction('instock')}
          />
        </div>
      ) : (
        <>
          <div className={`${styles.switchRow}`}>
            <div className={`${styles.titlewrapper}`}>
              <span className={`${styles.title}`}>{'خدمات سیار (در محل)'}</span>
              <span className={`${styles.text}`}>اعزام کارشناس به محل شما</span>
            </div>
            <Toggle
              state={searchParams?.get('inplace') ? true : false}
              onClick={() => stockFunction('inplace')}
            />
          </div>
          <div className={`${styles.switchRow}`}>
            <div className={`${styles.titlewrapper}`}>
              <span className={`${styles.title}`}>دارای گارانتی خدمات</span>
              <span className={`${styles.text}`}>ضمانت کیفیت کار</span>
            </div>
            <Toggle
              state={searchParams?.get('warranty') ? true : false}
              onClick={() => stockFunction('warranty')}
            />
          </div>
        </>
      )}
    </aside>
  );
}
